import { useEffect } from 'react';
// @ts-ignore
import styles from './TimelineGridColumn.module.scss';
import { ITimelineGridColumnItem } from '../../Models/TimelineGrid/ITimelineGridColumnItem';

export default function TimelineGridColumnItem(props: ITimelineGridColumnItem) {
	const { title, color } = props;

	useEffect(() => {
		// @ts-ignore
		$('[data-toggle="tooltip"]').tooltip();
	}, []);

	const handleClick = () => {
		console.log('Clicked at item');
	};

	return (
		<div
			className={styles.item}
			style={{ backgroundColor: color }}
			data-toggle='tooltip'
			data-placement='top'
			title={title}
			onClick={handleClick}
		/>
	);
}
